import { render, staticRenderFns } from "./outerCaseManagementDetail.vue?vue&type=template&id=3fbfa87f&scoped=true"
import script from "./outerCaseManagementDetail.vue?vue&type=script&lang=js"
export * from "./outerCaseManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./outerCaseManagementDetail.vue?vue&type=style&index=0&id=3fbfa87f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbfa87f",
  null
  
)

export default component.exports